import React from 'react';
import { Layout } from 'antd';

import RootLayout from '../../layout/Layout';
import FormCards from '../../components/FormCards';

import './style.css';

const Home = () => {
  return (
    <RootLayout innerClass="home-page-layout">
      <Layout className="site-layout-background">
        <FormCards />
      </Layout>
    </RootLayout>
  );
};

export default Home;
